// extracted by mini-css-extract-plugin
export var drawer = "info-modal-module--drawer--3x7Ig";
export var drawerContent = "info-modal-module--drawerContent--27yAB";
export var header = "info-modal-module--header--3nlGS";
export var closeButton = "info-modal-module--closeButton--2u6MQ";
export var row = "info-modal-module--row--1jb6l";
export var client = "info-modal-module--client--3BDh-";
export var copy = "info-modal-module--copy--V657j";
export var detailsCopy = "info-modal-module--detailsCopy--1b3ex";